var map = {
	"./blue_economy_color.svg": "87c0",
	"./business_in_transition_color.svg": "67ed",
	"./green_use_of_land_color.svg": "5360",
	"./social_economy_color.svg": "ace7",
	"./sustainable_energy_color.svg": "f789"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b96f";